// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/VITAL CLIC IMAGEN1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 stroke=%27%23667085%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero container ── */
.Form_homeContainer__q2Hh2 {
  background:
    linear-gradient(135deg, rgba(26, 58, 92, 0.88) 0%, rgba(20, 90, 110, 0.8) 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.4em;
  padding: 80px 1em 2em;
  box-sizing: border-box;
}

/* ── Badge superior ── */
.Form_badge__yh8lk {
  background-color: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.5px;
  padding: 6px 18px;
  border-radius: 20px;
  text-transform: uppercase;
}

/* ── Título principal ── */
.Form_heroTitle__3mJD0 {
  color: #ffffff;
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 700;
  text-align: center;
  line-height: 1.25;
  margin: 0;
}

.Form_highlight__vHj-o {
  color: #2db899;
  font-style: italic;
}

/* ── Subtítulo ── */
.Form_heroSubtitle__DtYaT {
  color: rgba(255, 255, 255, 0.82);
  font-size: clamp(0.9rem, 2vw, 1.05rem);
  text-align: center;
  line-height: 1.6;
  margin: 0;
  max-width: 560px;
}

/* ── Card de búsqueda ── */
.Form_SearchForm_container__jwpYy {
  background: #ffffff;
  border-radius: 16px;
  padding: 2em 2.4em;
  width: 100%;
  max-width: 720px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}

/* ── Tabs ── */
.Form_modeToggle__0fVc9 {
  display: flex;
  justify-content: flex-start;
  gap: 0.5em;
  margin-bottom: 1.6em;
}

.Form_tab__eK9jd {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  background: transparent;
  color: #667085;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.Form_tab__eK9jd:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

.Form_activeTab__6FFLl {
  background-color: #1a3a5c;
  color: #ffffff;
  border-color: #1a3a5c;
  font-weight: 600;
}

/* ── Formulario ── */
.Form_form__XXVs1 {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.Form_formGrid__iRsmK {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  margin-bottom: 1.4em;
}

.Form_formField__zpFQj {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Form_fieldLabel__Refeo {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #667085;
  text-transform: uppercase;
}

.Form_select__BzJZ- {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #ffffff;
  outline: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  transition: border-color 0.2s;
}

.Form_select__BzJZ-:focus {
  border-color: #1a3a5c;
}

.Form_select__BzJZ-:disabled {
  background-color: #f9fafb;
  color: #98a2b3;
  cursor: not-allowed;
}

/* ── Botón buscar ── */
.Form_searchButton__P6V86 {
  width: 100%;
  padding: 14px;
  background-color: #1a3a5c;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.Form_searchButton__P6V86:hover {
  background-color: #142e4a;
}

/* ── Badges de características ── */
.Form_featureBadges__gu\\+-L {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.6em;
  margin-top: 0.4em;
}

.Form_featureItem__G3KGO {
  color: rgba(255, 255, 255, 0.88);
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.Form_checkIcon__XHfI8 {
  display: inline-block;
  width: 14px;
  height: 14px;
  min-width: 14px;
  background-color: #2db899;
  border-radius: 3px;
}

/* ── Responsive ── */
@media screen and (max-width: 600px) {
  .Form_SearchForm_container__jwpYy {
    padding: 1.4em 1.2em;
    border-radius: 12px;
  }

  .Form_formGrid__iRsmK {
    grid-template-columns: 1fr;
  }

  .Form_heroTitle__3mJD0 {
    font-size: 1.8rem;
  }

  .Form_featureBadges__gu\\+-L {
    gap: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home/Form.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE;;2CAEqD;EACrD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yDAAgP;EAChP,4BAA4B;EAC5B,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* ── Hero container ── */\n.homeContainer {\n  background:\n    linear-gradient(135deg, rgba(26, 58, 92, 0.88) 0%, rgba(20, 90, 110, 0.8) 100%),\n    url(\"../../assets/Images/VITAL\\ CLIC\\ IMAGEN1.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.4em;\n  padding: 80px 1em 2em;\n  box-sizing: border-box;\n}\n\n/* ── Badge superior ── */\n.badge {\n  background-color: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  padding: 6px 18px;\n  border-radius: 20px;\n  text-transform: uppercase;\n}\n\n/* ── Título principal ── */\n.heroTitle {\n  color: #ffffff;\n  font-size: clamp(2rem, 5vw, 3.2rem);\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.highlight {\n  color: #2db899;\n  font-style: italic;\n}\n\n/* ── Subtítulo ── */\n.heroSubtitle {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: clamp(0.9rem, 2vw, 1.05rem);\n  text-align: center;\n  line-height: 1.6;\n  margin: 0;\n  max-width: 560px;\n}\n\n/* ── Card de búsqueda ── */\n.SearchForm_container {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 2em 2.4em;\n  width: 100%;\n  max-width: 720px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  box-sizing: border-box;\n}\n\n/* ── Tabs ── */\n.modeToggle {\n  display: flex;\n  justify-content: flex-start;\n  gap: 0.5em;\n  margin-bottom: 1.6em;\n}\n\n.tab {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  background: transparent;\n  color: #667085;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.tab:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n.activeTab {\n  background-color: #1a3a5c;\n  color: #ffffff;\n  border-color: #1a3a5c;\n  font-weight: 600;\n}\n\n/* ── Formulario ── */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1em;\n  margin-bottom: 1.4em;\n}\n\n.formField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fieldLabel {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  color: #667085;\n  text-transform: uppercase;\n}\n\n.select {\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #ffffff;\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23667085' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  transition: border-color 0.2s;\n}\n\n.select:focus {\n  border-color: #1a3a5c;\n}\n\n.select:disabled {\n  background-color: #f9fafb;\n  color: #98a2b3;\n  cursor: not-allowed;\n}\n\n/* ── Botón buscar ── */\n.searchButton {\n  width: 100%;\n  padding: 14px;\n  background-color: #1a3a5c;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.searchButton:hover {\n  background-color: #142e4a;\n}\n\n/* ── Badges de características ── */\n.featureBadges {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.6em;\n  margin-top: 0.4em;\n}\n\n.featureItem {\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.checkIcon {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  min-width: 14px;\n  background-color: #2db899;\n  border-radius: 3px;\n}\n\n/* ── Responsive ── */\n@media screen and (max-width: 600px) {\n  .SearchForm_container {\n    padding: 1.4em 1.2em;\n    border-radius: 12px;\n  }\n\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .heroTitle {\n    font-size: 1.8rem;\n  }\n\n  .featureBadges {\n    gap: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeContainer": `Form_homeContainer__q2Hh2`,
	"badge": `Form_badge__yh8lk`,
	"heroTitle": `Form_heroTitle__3mJD0`,
	"highlight": `Form_highlight__vHj-o`,
	"heroSubtitle": `Form_heroSubtitle__DtYaT`,
	"SearchForm_container": `Form_SearchForm_container__jwpYy`,
	"modeToggle": `Form_modeToggle__0fVc9`,
	"tab": `Form_tab__eK9jd`,
	"activeTab": `Form_activeTab__6FFLl`,
	"form": `Form_form__XXVs1`,
	"formGrid": `Form_formGrid__iRsmK`,
	"formField": `Form_formField__zpFQj`,
	"fieldLabel": `Form_fieldLabel__Refeo`,
	"select": `Form_select__BzJZ-`,
	"searchButton": `Form_searchButton__P6V86`,
	"featureBadges": `Form_featureBadges__gu+-L`,
	"featureItem": `Form_featureItem__G3KGO`,
	"checkIcon": `Form_checkIcon__XHfI8`
};
export default ___CSS_LOADER_EXPORT___;
